<template>
  <div class="cosmo-header">
    <div class="gheader">
      <div class="gheader__content">
        <p class="gheader__logo-corp">
          <template v-if="cosmoMode">
            <span class="gheader__logo-corp__content">
              <img src="https://storage.googleapis.com/storelocator-v3-static/images/cosmo/064c6f82-b0e2-4616-b55c-d836d95f6ebe.png"
                alt="COSMO">
            </span>
          </template>
          <template v-else>
            <a class="gheader__logo-corp__content" href="https://www.cosmo-energy.co.jp/ja/top.html">
              <img src="https://storage.googleapis.com/storelocator-v3-static/images/cosmo/064c6f82-b0e2-4616-b55c-d836d95f6ebe.png"
                alt="COSMO">
            </a>
          </template>
        </p>
        <div class="uk-navbar-right" v-if="!cosmoMode">
          <!-- ハンバーガーメニューのトグルボタン -->
          <a class="uk-navbar-toggle" uk-toggle="target: #offcanvas-nav" href="#">
            <span uk-navbar-toggle-icon></span>
          </a>
        </div>
      </div>
    </div>

    <div id="offcanvas-nav" uk-offcanvas="flip: true; overlay: true">
      <div class="uk-offcanvas-bar">
        <h3 class="title">
          <button class="uk-offcanvas-close" type="button" uk-close></button>
        </h3>
        <ul class="uk-nav uk-nav-default">
          <li
            v-for="(item, index) in LINK_ITEMS"
            :key="index"
          >
            <a :href="item.href" :class="{'active': item.active }">{{ item.name }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>

</template>

<script setup lang="ts">

/**
 * 外部サイトから遷移してきた際の外部サイトのID
 * こちらの値が入っていた場合は、ヘッダ、フッタのリンクを表示させない
 */
const cosmoMode = storelocator.url_params?.cosmo_mode || ''

/** ハンバーガーメニュー内のリンク、特に管理機能など設けないので固定値 */
const LINK_ITEMS = [
  {
    name: "サービスステーション新店舗情報",
    href: "https://www.cosmo-energy.co.jp/ja/services/ss/open.html",
    active: false,
  },
  {
    name: "セルフの使い方と禁止事項",
    href: "https://www.cosmo-energy.co.jp/ja/services/ss/self.html",
    active: false,
  },
  {
    name: "QRコード決済　利用可能SS",
    href: "https://www.cosmo-energy.co.jp/ja/services/ss/qr.html",
    active: false,
  },
  {
    name: "EV充電サービス",
    href: "https://www.cosmo-energy.co.jp/ja/services/ss/ev.html",
    active: false,
  },
  {
    name: "サービスステーションFAQ（よくあるご質問）",
    href: "https://www.cosmo-energy.co.jp/ja/services/ss/faq.html",
    active: false,
  }
]

</script>

<style lang="scss" scoped>
.cosmo-header {
  
  /* override uikit */

  .uk-navbar-toggle {
    min-height: auto;
  }
  .uk-offcanvas-bar {
    background-color: transparent;
    padding: 0px;
    background-color: #f5f7fd;
  }
  .uk-offcanvas-close {
    top: 16px;
    right: 16px;
    color: #fff;
  }

  /* メニュー */
  #offcanvas-nav .title { 
    text-align: center;
    display: flex;
    margin: 0;
    background-color: #2c31a6;
    font-weight: 700;
    height: 56px;
    position: relative;
    > a {
      color: #fff;
      font-size: 1rem;
      text-decoration: none;
      transition: color .3s;
      &:hover {
        color: #ccc;
      }
    }
  }
  #offcanvas-nav li {
    border-bottom: 1px solid #cfd8dc;
  }
  #offcanvas-nav ul > li > a {
    padding: 12px 16px 15px 44px;
    background-color: #f5f7fd;
    letter-spacing: .1em;
    color: #000;
    font-size: 14px;
    line-height: 2.05714;
    text-decoration: none;
    display: block;
    position: relative;
    transition: background-color .3s;
    &:before {
      content: "";
      width: 5px;
      height: 9px;
      background-image: url(data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%224.608%22%20height%3D%228.002%22%20viewBox%3D%220%200%204.608%208.002%22%3E%3Cg%20transform%3D%22translate\(-31.905%2013.923\)%22%20fill%3D%22%2300AD92%22%3E%3Cpath%20d%3D%22M32.094-6.1a.6.6%2C0%2C0%2C1%2C0-.849l2.97-2.97L32.081-12.9a.6.6%2C0%2C0%2C1%2C0-.849.6.6%2C0%2C0%2C1%2C.849%2C0l3.394%2C3.394.021.022a.6.6%2C0%2C0%2C1-.007.84L32.943-6.1a.6.6%2C0%2C0%2C1-.424.175A.6.6%2C0%2C0%2C1%2C32.094-6.1Z%22%20stroke%3D%22none%22%2F%3E%3Cpath%20d%3D%22M%2032.5186882019043%20-5.921100616455078%20C%2032.36512756347656%20-5.921100616455078%2032.21144866943359%20-5.979600429534912%2032.09399795532227%20-6.096600532531738%20C%2031.85999870300293%20-6.33150053024292%2031.85999870300293%20-6.711300849914551%2032.09399795532227%20-6.945300579071045%20L%2035.06439971923828%20-9.914910316467285%20L%2032.08049774169922%20-12.89880084991455%20C%2031.84649848937988%20-13.1328010559082%2031.84649848937988%20-13.51260089874268%2032.08049774169922%20-13.7475004196167%20C%2032.31539535522461%20-13.98149871826172%2032.69519424438477%20-13.98150444030762%2032.92919921875%20-13.7475004196167%20L%2036.32309722900391%20-10.35360050201416%20C%2036.33023071289062%20-10.34647083282471%2036.33710861206055%20-10.33923053741455%2036.34379959106445%20-10.33184051513672%20C%2036.57143783569336%20-10.09731101989746%2036.56906890869141%20-9.722970962524414%2036.33659744262695%20-9.491400718688965%20L%2032.94269943237305%20-6.096600532531738%20C%2032.82569885253906%20-5.979600429534912%2032.67224884033203%20-5.921100616455078%2032.5186882019043%20-5.921100616455078%20Z%22%20stroke%3D%22none%22%20fill%3D%22%2300AD92%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E);
      background-repeat: no-repeat;
      background-size: 100%;
      display: block;
      position: absolute;
      top: 23px;
      left: 23px;
    }
    &:hover {
      background-color: #edf0fb;
    }
    &.active{
      color: #2c31a6;
      background-color: #dee3f2;
      font-weight: 700;
      &:before {
        width: 9px;
        height: 5px;
        background-image: url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%229.312%22%20height%3D%225.356%22%20viewBox%3D%220%200%209.312%205.356%22%3E%3Cpath%20d%3D%22M.205%2C9.107a.7.7%2C0%2C0%2C1%2C0-.989L3.667%2C4.657.205%2C1.194A.7.7%2C0%2C0%2C1%2C1.2.205L5.151%2C4.161a.7.7%2C0%2C0%2C1%2C0%2C.99l-.022.021L1.193%2C9.107a.7.7%2C0%2C0%2C1-.988%2C0Z%22%20transform%3D%22translate(9.312)%20rotate(90)%22%20fill%3D%22%2300ad92%22%2F%3E%3C%2Fsvg%3E');
      }
    }
  }

  /* 本体サイト（https://www.cosmo-energy.co.jp/）からスタイル流用 */
  .gheader__content {
    -webkit-tap-highlight-color: transparent;
    background: #fff;
    border-top: 8px solid #2c31a6;
    border-bottom: 1px solid #cfd8dc;
    grid-template-rows: auto auto;
    grid-template-columns: auto auto;
    padding: 20px 32px 20px 20px;
    line-height: 1.5;
    display: grid;
    position: relative;
    top: 0;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    height: 81px;

    .gheader__logo-corp {
      align-self: flex-start;
      width: 128px;
      height: 24px;
      order: 0 !important;
      margin: 0;
    }
    .gheader__logo-corp img {
      width: 100%;
      display: block;
    }
  }

  .gheader__content:before {
    content: "";
    width: 34.7222%;
    height: 8px;
    background: #00ad92;
    display: block;
    position: absolute;
    top: -8px;
    left: 0;
  }

  .gheader__content:after {
    content: "";
    width: 6.04167%;
    height: 8px;
    background: #fc2e14;
    display: block;
    position: absolute;
    top: -8px;
    right: 0;
  }

  .gheader__content a {
    text-decoration: none;
  }

  .gheader__content * {
    box-sizing: border-box;
  }

}
</style>
